import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { KizenTypography } from '__app/typography';
import {
  setShowBlocker,
  setRefreshCounter,
} from 'store/authentication/authenticationAction';
import BasicModal from '__components/Modals/presets/BasicModal';
import {
  BLOCKER_DATA_TYPES,
  ShowBlockerData,
  getShowBlockerBroadcastChannel,
} from 'store/authentication/channels';
import styled from '@emotion/styled';
import { DEFAULT_PATHS } from 'routes/paths';
import Button from '__components/Button';

const BodyLayout = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const redirectPathnames = [DEFAULT_PATHS.CHOOSE_BUSINESS];

export const Blocker = () => {
  const { showBlocker, instanceId, refreshCounter } = useSelector(
    (s: any) => s.authentication
  );
  const isPublicPage = document.location.pathname.startsWith('/embed');

  const { t } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    const bc = getShowBlockerBroadcastChannel(
      ({ type, senderId }: ShowBlockerData) => {
        switch (type) {
          case BLOCKER_DATA_TYPES.session_timeout:
            dispatch(setShowBlocker(true));
            break;
          case BLOCKER_DATA_TYPES.log_out:
          case BLOCKER_DATA_TYPES.change_business:
            if (instanceId !== senderId) {
              dispatch(setShowBlocker(true));
            }
            break;
          case BLOCKER_DATA_TYPES.force_logout:
            if (instanceId !== senderId) {
              window.location.replace('/logout?skip=true');
            }
            break;
          default:
            dispatch(setShowBlocker(true));
        }
      }
    );
    return () => {
      bc.close();
    };
  }, [dispatch, instanceId]);

  return (
    <>
      <BasicModal
        show={showBlocker && !isPublicPage}
        heading={t('Session Expired')}
        buttonText={t('Refresh')}
        showHeaderCloseButton={false}
        onConfirm={() => {
          if (refreshCounter === 0) {
            // 1 time refresh
            const { pathname } = document.location;
            dispatch(setRefreshCounter(1));
            if (redirectPathnames.includes(pathname)) {
              window.location.replace('/');
            } else {
              document.location.reload();
            }
          } else {
            window.location.replace('/logout');
          }
        }}
        leftBtn={<Button variant="text" color="blue" />}
        defaultLeftBtnText={t('Log Out')}
        defaultLeftBtnHandler={() => {
          window.location.replace('/logout');
        }}
        className="session-blocker"
      >
        <BodyLayout>
          <KizenTypography>
            {t('Your Kizen session has expired.')}
          </KizenTypography>
          <KizenTypography>{t('Please refresh your session.')}</KizenTypography>
        </BodyLayout>
      </BasicModal>
    </>
  );
};
